import React from 'react'
import styled from 'styled-components'
import { colors } from '../../healtheraComponents'
import { formatDateTime } from '../../utils/formatters'

const Notes = ({ notes, showHeader, showButton, name}) => (
  <NotesWrapper>
    {showHeader && <NotesHeader>Notes</NotesHeader>}
    {notes && notes.length === 0 && <NoteContent> No notes</NoteContent>}
    {notes && notes.length > 0 && notes.map(({ id, comment, person, timestamp }) => (
      <Note key={id}>
        <NoteInfo>{`${name}, ${formatDateTime(timestamp)}`}</NoteInfo>
        <NoteContent>{comment}</NoteContent>
      </Note>
    ))}
    {showButton && <Button href="#">Message Patient</Button>}
  </NotesWrapper>
)

export default Notes

export const NotesWrapper = styled.div`
  align-items: flex-start;
  background-color: ${colors.GRAY_LIGHTER};
  display: flex;
  flex-direction: column;
  width: 320px;
`

export const NotesHeader = styled.div`
  width: 100%;
  align-items: center;
  border-bottom: 1px solid ${colors.GRAY_LIGHT};
  display: flex;
  font-size: 18px;
  font-weight: bold;
  height: 31px;
  margin-bottom: 16px;
  padding: 19px 25px 19px 15px;
`

export const Note = styled.div`
  border-left: 3px solid ${colors.GRAY_DARK};
  margin: 0 12px 16px 12px;
  padding-left: 8px;
`

export const NoteInfo = styled.div`
  color: ${colors.GRAY};
  font-size: 10px;
  margin-bottom: 8px;
`

export const NoteContent = styled.div`
  color: ${colors.GRAY_DARK};
  font-size: 16px;
  white-space: pre-wrap;
`

export const Button = styled.a`
  border-left: 3px solid;
  color: ${colors.HEALTHERA_GREEN};
  font-size: 16px;
  font-weight: 600;
  margin: auto 0 17px 12px;
  padding: 2px 8px;
  text-decoration: none;
`
